import { Link } from "react-router-dom";
import { SealCheck, ArrowRight } from "@phosphor-icons/react";
import { PageHero, PageBlock, RelatedLinks, PageCta } from "@/components/PageLayout";

export default function GestionDeProjets({ t }) {
  const p = t.pages.gestionDeProjets;
  const c = t.pages.common;
  return (
    <>
      <PageHero overline={p.overline} title={p.h1} intro={p.intro} back={c.back} />

      <PageBlock title={p.situationsTitle} testid="gp-situations">
        <div className="grid md:grid-cols-2 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
          {p.situations.map((s, i) => (
            <div key={s.name} className="bg-white p-8 lg:p-10">
              <span className="font-heading text-xs font-bold tracking-widest text-[#9AA5B1]">0{i + 1}</span>
              <h3 className="font-heading text-lg font-bold tracking-tight text-[#0B1B3D] mt-3 mb-3">{s.name}</h3>
              <p className="text-sm leading-relaxed text-[#5A6B7C]">{s.text}</p>
            </div>
          ))}
        </div>
      </PageBlock>

      <PageBlock title={p.scopeTitle} gray testid="gp-scope">
        <div className="grid md:grid-cols-3 gap-x-10 gap-y-12">
          {p.scope.map((s) => (
            <div key={s.name} className="border-t-2 border-[#0B1B3D] pt-6">
              <h3 className="font-heading text-base font-bold tracking-tight text-[#0B1B3D] mb-6">{s.name}</h3>
              <ul className="space-y-3">
                {s.items.map((it) => (
                  <li key={it} className="flex items-start gap-3 text-sm text-[#5A6B7C] leading-snug">
                    <span className="text-[#9AA5B1] select-none leading-none mt-0.5">—</span>
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </PageBlock>

      <PageBlock title={p.deliverablesTitle} testid="gp-deliverables">
        <div className="grid lg:grid-cols-12 gap-10">
          <p className="lg:col-span-4 text-base leading-relaxed text-[#5A6B7C]">{p.deliverablesText}</p>
          <ul className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
            {p.deliverables.map((d) => (
              <li key={d} className="bg-white px-6 py-5 font-heading text-base font-semibold tracking-wide text-[#2A2D34]">{d}</li>
            ))}
          </ul>
        </div>
      </PageBlock>

      <PageBlock title={p.principlesTitle} gray testid="gp-principles">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
          {p.principles.map((pr) => (
            <div key={pr.name}>
              <span className="block h-px bg-[#0B1B3D] mb-6" />
              <h3 className="font-heading text-sm font-bold tracking-[0.15em] uppercase text-[#0B1B3D] mb-3">{pr.name}</h3>
              <p className="text-sm text-[#5A6B7C] leading-relaxed">{pr.text}</p>
            </div>
          ))}
        </div>
        <p className="mt-14 inline-flex items-center gap-3 border border-[#0B1B3D] text-[#0B1B3D] text-sm font-medium px-4 py-3" data-testid="gp-certification">
          <SealCheck size={20} weight="light" />
          {p.certification}
        </p>
      </PageBlock>

      <PageBlock title={p.sectorsTitle} testid="gp-sectors">
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {p.sectors.map((s) => (
            <Link key={s.href} to={s.href} className="group block bg-[#F4F5F7] p-8 hover:bg-[#E9ECF0] transition-colors">
              <h3 className="font-heading text-lg font-bold tracking-tight text-[#0B1B3D] mb-3 inline-flex items-center gap-2">
                {s.label}
                <ArrowRight size={16} weight="light" className="group-hover:translate-x-1 transition-transform" />
              </h3>
              <p className="text-sm text-[#5A6B7C] leading-relaxed">{s.text}</p>
            </Link>
          ))}
        </div>
        <RelatedLinks label={c.related} links={p.related} />
      </PageBlock>

      <PageCta title={c.ctaTitle} text={c.ctaText} cta={t.cta} />
    </>
  );
}
